import React, {useContext, useEffect, useState} from "react";
import {
    convertiDateInDataPerDb
} from "../../utility/common";
import {TranslateContext} from "../../context/TranslateContext";
import {useHistory} from "react-router-dom";
import {isNumber} from "chart.js/helpers";
import {deleteUtenteApi, getUtentiApi} from "./services/UtentiServices";
import {getRuoliApi} from "../ruoli/services/RuoliServices";
import ConfUtentiView from "./ConfUtentiView";

export default function ConfUtentiController() {

    const [loadingData, setLoadingData] = useState(true);
    const [data, setData] = useState([]);
    const [utenteSel, setUtenteSel] = useState(null);
    const [show, setShow] = useState(false);
    const [pagina, setPagina] = useState(1);
    const [totPagine, setTotPagine] = useState();
    const [totUtenti, setUtenti] = useState();
    const [orderByCol, setOrderByCol] = useState();
    const [orderByDir, setOrderByDir] = useState();
    const [optionsRuoli, setOptionsRuoli] = useState([]);
    const [filtro, setFiltro] = useState({
        nome: '',
        cognome: '',
        mail: '',
        id_ruolo: '',
        registrazione: '',
        attivo: '',
    });

    const {translate} = useContext(TranslateContext);
    const history = useHistory();

    async function getUtenti() {
        let f = '?pag=' + pagina;
        if (filtro && filtro.nome && filtro.nome !== '') {
            f += '&nome=' + filtro.nome;
        }
        if (filtro && filtro.cognome && filtro.cognome !== '') {
            f += '&cognome=' + filtro.cognome;
        }
        if (filtro && filtro.mail && filtro.mail !== '') {
            f += '&mail=' + filtro.mail;
        }
        if (filtro && filtro.id_ruolo && filtro.id_ruolo !== '') {
            f += '&id_ruolo=' + filtro.id_ruolo;
        }
        if (filtro && filtro.registrazione && filtro.registrazione !== '') {
            f += '&registrazione=' + convertiDateInDataPerDb(filtro.registrazione);
        }
        if (filtro && filtro.attivo && filtro.attivo !== '') {
            f += '&attivo=' + filtro.attivo;
        }
        if (orderByCol && orderByCol !== '' && orderByDir && orderByDir !== '') {
            f += `&orderByCol=${orderByCol}&orderByDir=${orderByDir}`;
        }

        const response = await getUtentiApi(f);
        setData(response.data.data);
        setTotPagine(response.data.pages)
        setUtenti(response.data.tot)
        setLoadingData(false);
    }

    const getRuoli = async function () {
        const response = await getRuoliApi();
        setOptionsRuoli(response.data.data);
    }

    useEffect(() => {
        getUtenti();
        getRuoli();
    }, [pagina]);


    // Use effect usato per i filtri di tipo lista
    useEffect(() => {
        if (pagina && isNumber(pagina)) {
            getUtenti();
        }
    }, [filtro.registrazione, filtro.attivo, filtro.id_ruolo, orderByCol, orderByDir]);

    const eliminaUtente = async () => {
        setShow(false);
        const response = await deleteUtenteApi(utenteSel.id_utente);
        setData(response.data.data);
        setTotPagine(response.data.pages)
        setUtenti(response.data.tot)
    }

    const bottoniDx = [
        {
            label: translate("Aggiungi"),
            icon: "fas fa-plus-circle",
            command: () => {
                history.push("/upd-utente");
            }
        }
    ];

    function onClickElimina(row) {
        setUtenteSel(row);
        setShow(true);
    }

    function onRowDbClickUtente(row) {
        history.push("/upd-utente/" + row.id_utente);
    }

    function onOrderBy(colonna, direzione) {
        setOrderByCol(colonna);
        setOrderByDir(direzione);
    }

    return (
        <ConfUtentiView
            loadingData={loadingData}
            translate={translate}
            setFiltro={setFiltro}
            utenteSel={utenteSel}
            show={show}
            data={data}
            getUtenti={getUtenti}
            setShow={setShow}
            eliminaUtente={eliminaUtente}
            filtro={filtro}
            optionsRuoli={optionsRuoli}
            orderByCol={orderByCol}
            orderByDir={orderByDir}
            pagina={pagina}
            setPagina={setPagina}
            totPagine={totPagine}
            totUtenti={totUtenti}
            bottoniDx={bottoniDx}
            onClickElimina={onClickElimina}
            onRowDbClickUtente={onRowDbClickUtente}
            onOrderBy={onOrderBy}
        />
    );
}
